import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import DocumentTitle from 'react-document-title'
import Paragraph from '@components/Details/Paragraph'
import Row from '@components/Details/Row'
import InfoPanel from './InfoPanel'
import Actions from './Actions'
import PropTypes from 'prop-types'
import { formatDate } from '@atheneum/api/dist/lib'
import { userApi } from '@atheneum/api'
import ACL from '@components/ACL/ACL'

class Details extends Component {
  handleResetPassword = () => {
    const { employeeStore, growlStore } = this.props
    const { email } = employeeStore.employee

    return userApi.forgotPassword({ email })
      .then(res => {
        growlStore.addNotification({
          title: 'Success!',
          message: 'Reset password link sent.',
          type: 'success',
          autoClose: true
        })
      })
      .catch(err => {
        growlStore.addNotification({
          title: 'Error!',
          message: err.message || 'There was an error.',
          type: 'error',
          autoClose: true
        })
      })
  }

  handleSendPlatformInvitationEmail = () => {
    const { employeeStore, growlStore } = this.props
    const { id } = employeeStore.employee

    return userApi.sendPlatformInvitationEmail(id)
      .then(res => {
        employeeStore.get(id)
        growlStore.addNotification({
          title: 'Success',
          message: 'Platform invitation email successfully sent',
          type: 'success',
          autoClose: true
        })
      })
      .catch(err => {
        growlStore.addNotification({
          title: 'Error!',
          message: err.message || 'There was an error.',
          type: 'error',
          autoClose: true
        })
      })
  }

  render () {
    const { employeeStore } = this.props
    const { employee } = employeeStore

    return (
      <DocumentTitle title={`Employee details | Atheneum Partners`}>
        <div className='details-wrapper'>
          <Actions employee={employee} />
          <InfoPanel employeeStore={employeeStore} />
          <div className='group-wrapper'>
            <h2>Rydoo</h2>
            <div className='group'>
              <Row label='First name' text={employee.employee.rydooFirstName} />
              <Row label='Last name' text={employee.employee.rydooLastName} />
              <Row label='Nick Name' text={employee.employee.rydooNickName} />
              <Row label='Group id' text={employee.employee.rydooGroupId} />
              <Row label='Group name' text={employee.employee.rydooGroupName} />
              <Row
                label='Payroll entity'
                text={employee.employee.rydooPayrollEntity.name}
              />
            </div>
          </div>
          <div className='employee-section'>
            <h2>Employee expertise</h2>
            <Paragraph value={employee.employee.expertize} />
          </div>
          <div className='comments-wrapper'>
            <p className='independent-label'>
              <span>Last login:</span> {formatDate(employee.lastLogin) || 'N/A'}
            </p>
            <p className='independent-label'>
              <span>Date created:</span> {formatDate(employee.created_at)}
            </p>
            <p className='independent-label'>
              <span>Platform invitation sent:</span>{' '}
              {formatDate(employee.platformInvitationDate) || 'N/A'}
            </p>
            <ACL roles={['Accounting', 'Admin']}>
              <p
                className='independent-label independent-label--blue'
                onClick={this.handleSendPlatformInvitationEmail}
              >
                Send platform invitation email
              </p>
              <p
                className='independent-label independent-label--blue'
                onClick={this.handleResetPassword}
              >
                Reset password
              </p>
            </ACL>
          </div>
        </div>
      </DocumentTitle>
    )
  }

  static propTypes = {
    employeeStore: PropTypes.object,
    growlStore: PropTypes.object
  }
}

export default inject('employeeStore', 'growlStore')(observer(Details))
